import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";

let responsiveLength = "1000";

let useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        margin: '100px auto',
        flexWrap: 'wrap',
        // backgroundColor: '#F6F7FF',
        padding: 50,
        [theme.breakpoints.down('400')]: {
            padding: "50px 20px",
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        right: '50%',
        [theme.breakpoints.down(responsiveLength)]: {
            top: -10,
            display: 'none'
        }
    },
    desc: {
        width: '50%',
        margin: "10px auto",
        fontSize: 16,
        minWidth: 600,
        maxWidth: '100%',
        [theme.breakpoints.down('750')]: {
            minWidth: '100%',
        },

    },
    content: {
        position: 'relative'
    },
    title: {
        fontSize: 30,
        fontWeight: 700,
    },
    gridBtns: {
        width: 750,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        margin: '50px auto',

        [theme.breakpoints.down('800')]: {
            width: '100%',
        },



    },
    btns: {
        width: 179,
        height: 50,
        borderRadius: 5,
        border: "none",
        fontSize: 16,
        backgroundColor: 'transparent',
        '&:hover': {
            background: "#EDEFFE",
            color: '#425BB4'
        },
        [theme.breakpoints.down('910')]: {
            minWidth: '50%',
        },
        [theme.breakpoints.down('510')]: {
            minWidth: '100%',
        },
    },
    btnActive: {
        background: "#EDEFFE",
        color: '#050A2A',
        fontWeight: 700,

    },
    descT: {
        width: '60%',
        fontSize: 16,
        maxWidth: '100%',
        margin: "10px auto",
        minHeight: 30,
        '@media (max-width: 910px)': {
            width: '98%',
        }
    },
    gridBtn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        margin: '45px auto 0px auto',
        '& > a': {
            [theme.breakpoints.down('500')]: {
                width: '100%',
                marginBottom: 10,
            },
        },
        '& > button ': {
            [theme.breakpoints.down('500')]: {

                marginBottom: 10,
            },
        },
    },
    btnWhite: {
        padding: '0px 33.5px',
        fontSize: 16,

        [theme.breakpoints.down('500')]: {
            width: '100%'
        },
    },
    btnRed: {
        margin: 5,
        fontSize: 16,
        padding: '0px 22.3px',
        [theme.breakpoints.down("500")]: {
            width: '100%',
            margin: 0,
        },
    },

}))

export default function Index() {

    let classes = useStyles();
    const history = useHistory();
    const [state, setstate] = useState({
        1: `
        سرمایه‌گذاری در بورس به معنای خرید و فروش اوراق بهادار و سهام شرکت‌ها با هدف کسب سود است. بورس یک بازار مالی است که در آن افراد و شرکت‌ها می‌توانند اوراق بهادار را خرید و فروش کنند.

برای سرمایه‌گذاران، این فرصت فراهم می‌شود تا با تحلیل و بررسی اطلاعات مربوط به شرکت‌ها و بازار، سرمایه خود را در سهام یا دیگر اوراق بهادار سرمایه‌گذاری کنند. سود حاصل از این سرمایه‌گذاری ممکن است از افزایش قیمت سهام، تقسیم سود شرکت، یا افزایش ارزش سایر اوراق بهادار باشد.
        `,
        2: `
        بورس کالا، بازاری است که تعداد زیادی از عرضه‌کنندگان، کالای خود را عرضه کرده و متقاضیان کالاهای عرضه شده را خریداری می کنند. در این بازار معمولاً کالاهای خام و فرآوری نشده مانند فلزات، محصولات پتروشیمی، سیمان، محصولات کشاورزی و… دادوستد می‌شوند.

البته به تازگی خودرو نیز به لیست کالاهای قابل معامله در بورس کالا اضافه شده است

در این بازار، کالای مربوطه پس از بررسی‌های کارشناسی و قیمت‌گذاری توسط کارشناسان بورس کالا، به خریداران عرضه می‌شود.
        `,
        3: `
        بورس انرژی بازاری است که مانند سایر بورس‌های کالایی، خریداران و فروشندگان زیادی در آن به‌منظور معامله حامل‌های انرژی یا اوراق بهادار مبتنی بر این کالاها حضور دارند و با انجام معاملات در بین آنها، قیمت این حامل‌ها به تعادل ‌می‌رسد. حامل‌های انرژی مانند نفت، گازوئیل، بنزین، حلالها،متانول، گاز، برق و...، کالاهایی هستند که قدرت انتقال انرژی را به صورت الکترونیکی یا شیمیایی دارند.بورس انرژی ایران به منظور نظم دادن به معاملات حامل‌های انرژی و دارایی‌های مبتنی بر این حامل‌ها، در سال 1384 جهت نظارت بر انجام معاملات و تسهیل فرآیند ثبت معاملات، تاسیس شده است.
        `,
        4: "",
    });

    const [indexSatet, setindexSatet] = useState(1);

    const handelRout = (key) => {
        switch (key) {
            case 1:
                window.open('https://reg.pouyanbroker.com/', '_blank')
                break;
            case 2:
                window.open('https://pouyan.ebgo.ir/', '_blank')
                break;
            default:
                break;
        }
    }

    const handelRoutHistory = (key) => {
        window.scrollTo(0, 0)
        switch (key) {
            case 1:
                history.push('/oragh')
                break;
            case 2:
                history.push('/kala')
                break;
            case 3:
                history.push('/energy')
                break;
            default:
                break;
        }
    }



    return (
        <div className={classes['root']}>
            <div className={classes['girdContent']}>
                <div className={classes['content']}>
                    <div className={classes['line']} />
                    <h3 className={classes['title']}>
                        کارگزاری پویان در
                    </h3>
                    {/* <p className={classes['desc']}>
                        بورس کالای ایران دارای 4 بازار اصلی است که هرکدام ویژگی‌های خاصی دارند تا نیازهای مختلف فعالان بازار پوشش داده شود.به عنوان مثال در یک بازار شاهد معاملات فلزات هستیم، در یک بازار معاملات گواهی تمام سکه بهار آزادی، در بازاری دیگری شاهد معاملات مواد پتروشیمی و...
                    </p> */}
                </div>
                <div className={classes['gridBtns']}>
                    <button type="text" className={`${classes['btns']} ${indexSatet === 1 ? classes['btnActive'] : ''}`} onClick={() => setindexSatet(1)}>
                        اوراق بهادار
                    </button>
                    <button type="text" className={`${classes['btns']} ${indexSatet === 2 ? classes['btnActive'] : ''}`} onClick={() => setindexSatet(2)}>
                        بورس کالا
                    </button>
                    <button type="text" className={`${classes['btns']} ${indexSatet === 3 ? classes['btnActive'] : ''}`} onClick={() => setindexSatet(3)}>
                        بورس انرژی
                    </button>
                    {/* <button type="text" className={`${classes['btns']} ${indexSatet === 4 ? classes['btnActive'] : ''}`} onClick={() => setindexSatet(4)}>
                        بازار آتی
                    </button> */}
                </div>
                <div>
                    <p className={classes['descT']}>
                        {state[indexSatet] ? state[indexSatet] : ''}
                    </p>
                </div>
                <div className={classes['gridBtn']}>
                    {
                        indexSatet != 3 && (
                            <button type="" className={`${classes['btnRed']} btnPouyanRed`}
                                onClick={() => handelRout(indexSatet)}
                            >
                                دریافت کد بورسی
                            </button>
                        )
                    }
                    <button type="text" className={`${classes['btnWhite']} btnPouyanWhite`}
                        onClick={() => handelRoutHistory(indexSatet)}
                    >
                        اطلاعات بیشتر
                    </button>
                </div>
            </div>
        </div>
    )
}
